import { render } from "./ShopSupportCard.vue?vue&type=template&id=3a9124a0&scoped=true"
import script from "./ShopSupportCard.vue?vue&type=script&lang=js"
export * from "./ShopSupportCard.vue?vue&type=script&lang=js"

import "./ShopSupportCard.vue?vue&type=style&index=0&id=3a9124a0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a9124a0"]])

export default __exports__